import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./components/ScrollToTop";
import Index from "./pages/Index";
import CalendarioSemine from "./pages/CalendarioSemine";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import NotFound from "./pages/NotFound";
import AlimentazioneAnimali from "./pages/products/AlimentazioneAnimali";
import MangimiAllevamento from "./pages/products/MangimiAllevamento";
import Fitosanitari from "./pages/products/Fitosanitari";
import ConcimiTerricci from "./pages/products/ConcimiTerricci";
import SementiPiantine from "./pages/products/SementiPiantine";
import Farine from "./pages/products/Farine";
import AttrezzaturaAgricola from "./pages/products/AttrezzaturaAgricola";
import PelletCombustibili from "./pages/products/PelletCombustibili";
import Professionisti from "./pages/Professionisti";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import CookieBanner from "./components/CookieBanner";

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/calendario-semine" element={<CalendarioSemine />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/prodotti/alimentazione-animali" element={<AlimentazioneAnimali />} />
            <Route path="/prodotti/mangimi-allevamento" element={<MangimiAllevamento />} />
            <Route path="/prodotti/fitosanitari" element={<Fitosanitari />} />
            <Route path="/prodotti/concimi-terricci" element={<ConcimiTerricci />} />
            <Route path="/prodotti/sementi-piantine" element={<SementiPiantine />} />
            <Route path="/prodotti/farine" element={<Farine />} />
            <Route path="/prodotti/attrezzatura-agricola" element={<AttrezzaturaAgricola />} />
            <Route path="/prodotti/pellet-combustibili" element={<PelletCombustibili />} />
            <Route path="/professionisti" element={<Professionisti />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
